import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import { HRService } from "../../../../config";
import {
  generateAndExecuteMutation,
} from "../../../../data/Axios/DynamicService";

const base_url = HRService.uri;

const PensionRatesForm = (props) => {
  const [loading, setLoading] = useState(false);

  const initialValues = {
    ratePercentage: props.data ? props.data.ratePercentage : "",
    description: props.data ? props.data.description : "",
    isActive: props.data ? props.data.isActive : false,
  };

  const fields = [
    {
      name: "ratePercentage",
      label: "Rate Percentage",
      type: "number",
      required: true,
      gridColumn: "span 2",
    },
    {
      name: "description",
      label: "Description",
      type: "textarea",
      gridColumn: "span 2",
    },
    {
      name: "isActive",
      label: "Is Active",
      type: "checkbox",
    },
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setLoading(true);
      const { ratePercentage, description, isActive } = values;
      const mutationData = {
        id: props.data ? props.data.id : null,
        ratePercentage: parseFloat(ratePercentage),
        description: description || null,
        isActive: isActive === true ? 1 : 0,
      };
      const mutationKey = props.data ? "updatePensionRate" : "createPensionRate";
      const entity = "pensionRate";
      const response = await generateAndExecuteMutation(
        mutationKey,
        mutationData,
        entity,
        base_url
      );
      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: props.data ? "Pension rate updated successfully." : "Pension rate created successfully.",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  return loading ? (
    <CircularProgress />
  ) : (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={props.data ? "Update Pension Rate" : "Create Pension Rate"}
      subtitle={props.data ? "Fill out the form below to update the pension rate." : "Fill out the form below to create a new pension rate."}
    />
  );
};

export default PensionRatesForm;